import { render, staticRenderFns } from "./BusinessDescription.vue?vue&type=template&id=2bfc7a40&scoped=true&"
import script from "./BusinessDescription.vue?vue&type=script&lang=ts&"
export * from "./BusinessDescription.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessDescription.vue?vue&type=style&index=0&id=2bfc7a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc7a40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer})
